module.exports = __webpack_public_path__ + "media/project/cookie-new-1ffaf63c.png";